import * as React from 'react';

// import * as React from 'react';

function SvgComponent(props) {
	return (
		<svg
			viewBox="0 0 485.656 485.656"
			{...props}
			width="400px"
			height="400px"
			c
		>
			<path
				fill="#b1c0ca"
				d="M334.512 312h-200a8 8 0 00-5.656 2.344l-96 96 11.312 11.312L137.824 328h187.888c-1.664 9.496-6.888 24-23.2 24h-88v16h88c31.64 0 40-31.4 40-48a8 8 0 00-8-8z"
			/>
			<path
				fill="#b1c0ca"
				d="M436.168 258.344a8 8 0 00-11.312 0l-72 72 11.312 11.312 65.712-65.712c10.828 14.37 8.629 34.68-5.024 46.4L331.2 416H166.512a8 8 0 00-5.656 2.344l-56 56 11.312 11.312L169.824 432h164.688a8 8 0 005.656-2.344l96-96c29.792-29.792 13.024-62.288 0-75.312zM390.512 112H361.76a111.297 111.297 0 00-8.792-21.192l20.344-20.344a8 8 0 000-11.312L339.36 25.208a8 8 0 00-11.312 0l-20.344 20.344a110.95 110.95 0 00-21.192-8.8V8a8 8 0 00-8-8h-48a8 8 0 00-8 8v28.752a110.95 110.95 0 00-21.192 8.8l-20.344-20.344a8 8 0 00-11.312 0l-33.952 33.944a8 8 0 000 11.312l20.352 20.344a111.392 111.392 0 00-8.8 21.192h-28.752a8 8 0 00-8 8v48a8 8 0 008 8h28.752a111.297 111.297 0 008.792 21.192l-20.344 20.344a8 8 0 000 11.312l33.952 33.952a8.232 8.232 0 0011.312 0l20.344-20.352a111.392 111.392 0 0021.192 8.8V280a8 8 0 008 8h48a8 8 0 008-8v-28.752a111.454 111.454 0 0021.192-8.792l20.344 20.344a8 8 0 0011.312 0l33.944-33.952a8 8 0 000-11.312l-20.344-20.344a111.392 111.392 0 008.8-21.192h28.752a8 8 0 008-8v-48a8 8 0 00-8-8zm-7.999 48h-26.888a8 8 0 00-7.784 6.16 95.729 95.729 0 01-11.68 28.144 8.001 8.001 0 001.152 9.864l19.032 19.024-22.64 22.64-19.024-19.04a8.001 8.001 0 00-9.864-1.152 95.436 95.436 0 01-28.144 11.688 8 8 0 00-6.16 7.784V272h-32v-26.88a8 8 0 00-6.16-7.784 95.436 95.436 0 01-28.144-11.688 8.001 8.001 0 00-9.864 1.152l-19.024 19.04-22.64-22.64 19.032-19.04a8.001 8.001 0 001.152-9.864 95.74 95.74 0 01-11.68-28.144 8 8 0 00-7.784-6.16h-26.888v-32H153.4a8 8 0 007.784-6.16 95.74 95.74 0 0111.68-28.144 8.001 8.001 0 00-1.152-9.864L152.68 64.8l22.632-22.624 19.032 19.032a8.001 8.001 0 009.864 1.152 95.198 95.198 0 0128.144-11.68 8 8 0 006.16-7.784V16h32v26.896a8 8 0 006.168 7.784 95.198 95.198 0 0128.144 11.68 8.001 8.001 0 009.864-1.152l19.024-19.032L356.345 64.8l-19.032 19.032a8.001 8.001 0 00-1.152 9.864 95.74 95.74 0 0111.68 28.144 8 8 0 007.784 6.16h26.888v32z"
			/>
			<path
				fill="#b1c0ca"
				d="M254.512 96c-26.51 0-48 21.49-48 48s21.491 48 48 48c26.499-.026 47.974-21.501 48-48 0-26.51-21.49-48-48-48zm0 80c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32z"
			/>
		</svg>
	);
}

export default SvgComponent;

// function SvgComponent(props) {
// 	return (
// 		<svg viewBox="0 0 512 512" width={300} height={300} {...props}>
// 			<circle
// 				cx={256}
// 				cy={256}
// 				r={245}
// 				data-original="#F24976"
// 				className="prefix__active-path"
// 				data-old_color="#F24976"
// 				fill="#4e4dae"
// 			/>
// 			<path
// 				data-original="#445EA0"
// 				fill="#445ea0"
// 				d="M211.24 383.73h89.53v44.43h-89.53z"
// 			/>
// 			<path
// 				data-original="#2E4C89"
// 				fill="#2e4c89"
// 				d="M211.24 383.73h19.842v44.43H211.24z"
// 			/>
// 			<path
// 				d="M345.098 453.795a4.443 4.443 0 01-4.429 4.43H171.331a4.444 4.444 0 01-4.43-4.43v-22.203a4.444 4.444 0 014.43-4.43h169.337a4.443 4.443 0 014.429 4.43v22.203h.001z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M186.744 453.795v-22.203a4.444 4.444 0 014.43-4.43h-19.842a4.444 4.444 0 00-4.43 4.43v22.203a4.444 4.444 0 004.43 4.43h19.842a4.444 4.444 0 01-4.43-4.43z"
// 				data-original="#1A2B63"
// 				fill="#1a2b63"
// 			/>
// 			<path
// 				d="M506.198 42.867H5.803C2.611 42.867 0 45.479 0 48.672v330.254c0 3.191 2.611 5.803 5.803 5.803h344.465v-17.345a3.206 3.206 0 013.203-3.203h13.486c2.754 0 5.62-2.039 6.525-4.641l2.547-6.119c1.198-2.417.621-5.879-1.34-7.821l-9.518-9.443c-.602-.599-.934-1.398-.934-2.251s.332-1.652.935-2.251l17.261-17.126a3.21 3.21 0 012.279-.932c.864 0 1.674.331 2.279.932l9.517 9.443c1.219 1.21 3.102 1.934 5.035 1.934 1.04 0 2.032-.216 2.869-.623l6.201-2.541c2.554-.871 4.598-3.73 4.598-6.487v-13.319a3.205 3.205 0 013.202-3.203h24.439a3.206 3.206 0 013.202 3.203v13.319c0 2.758 2.044 5.616 4.653 6.509l6.207 2.546c.777.381 1.77.596 2.809.596 1.934 0 3.816-.723 5.036-1.933l9.518-9.443c.605-.601 1.414-.932 2.278-.932s1.673.331 2.278.932l17.258 17.127a3.15 3.15 0 01.935 2.251c0 .852-.333 1.652-.935 2.25l-9.515 9.444c-1.961 1.941-2.538 5.403-1.314 7.88l2.542 6.114c.882 2.547 3.747 4.586 6.503 4.586h13.487a3.206 3.206 0 013.203 3.203v14.788c.631-.928 1-2.046 1-3.246V48.672c.003-3.193-2.608-5.805-5.799-5.805z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M25.473 326.701a3.492 3.492 0 003.482 3.482h337.701l15.778-15.655a3.21 3.21 0 012.279-.932c.864 0 1.674.331 2.279.932l9.517 9.443c1.219 1.21 3.102 1.934 5.035 1.934 1.04 0 2.032-.216 2.869-.623l6.201-2.541c2.554-.871 4.598-3.73 4.598-6.487v-13.319a3.205 3.205 0 013.202-3.203h24.439a3.206 3.206 0 013.202 3.203v13.319c0 2.758 2.044 5.616 4.653 6.509l6.207 2.546c.777.381 1.77.596 2.809.596 1.934 0 3.816-.723 5.036-1.933l9.518-9.443c.605-.601 1.414-.932 2.278-.932s1.673.331 2.278.932l7.692 7.634V99.913H25.473v226.788z"
// 				data-original="#FFFFFF"
// 				fill="#fff"
// 			/>
// 			<path
// 				d="M45.315 326.701V99.913H25.473v226.788a3.492 3.492 0 003.482 3.482h19.842a3.491 3.491 0 01-3.482-3.482z"
// 				data-original="#D9EAFC"
// 				fill="#d9eafc"
// 			/>
// 			<path
// 				d="M249.615 253.532c-9.128-9.128-22.482-11.506-33.822-7.15l-38.259-38.259-7.691 7.691a1.002 1.002 0 00-.288.811 8.825 8.825 0 01-1.738 6.265 1 1 0 00-.05 1.138c2.131 3.384 1.903 7.5-.515 10.134l30.38 30.38c-4.357 11.339-1.979 24.695 7.15 33.824 7.902 7.902 19.084 11.038 29.911 8.389a1.601 1.601 0 001.163-1.127c.157-.559 0-1.158-.41-1.567l-19.516-19.518 19.861-19.862 19.517 19.519a1.607 1.607 0 002.694-.756c2.652-10.828-.484-22.009-8.387-29.912zM148.928 208.658c1.713 0 3.415.502 4.924 1.452a1.004 1.004 0 001.138-.05 8.75 8.75 0 015.338-1.784c.309 0 .619.016.927.048a1 1 0 00.81-.288l7.692-7.692-38.259-38.258c4.356-11.34 1.978-24.695-7.15-33.822-7.903-7.903-19.084-11.04-29.911-8.39a1.616 1.616 0 00-1.165 1.128 1.603 1.603 0 00.412 1.567l19.516 19.516-19.862 19.863-19.517-19.518c-.409-.41-1.009-.566-1.567-.41a1.58 1.58 0 00-.702.41 1.596 1.596 0 00-.425.754c-2.65 10.826.487 22.009 8.388 29.91 9.129 9.129 22.483 11.507 33.824 7.151l30.381 30.381c1.38-1.267 3.214-1.968 5.208-1.968z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<circle
// 				cx={256}
// 				cy={357.35}
// 				r={15.667}
// 				data-original="#445EA0"
// 				fill="#445ea0"
// 			/>
// 			<path
// 				d="M483.047 72.461H28.955a3.492 3.492 0 00-3.482 3.482v24.97h461.054v-24.97a3.49 3.49 0 00-3.48-3.482z"
// 				data-original="#5DC1D8"
// 				fill="#5dc1d8"
// 			/>
// 			<path
// 				d="M48.797 72.461H28.955a3.492 3.492 0 00-3.482 3.482v24.97h19.842v-24.97a3.492 3.492 0 013.482-3.482z"
// 				data-original="#28A5A5"
// 				fill="#28a5a5"
// 			/>
// 			<path
// 				d="M414.212 456.022a4.214 4.214 0 004.202 4.202h24.439a4.215 4.215 0 004.202-4.202v-13.318c0-2.311 1.789-4.815 3.977-5.564l6.264-2.566c2.079-1.013 5.121-.508 6.761 1.121l9.518 9.445c1.64 1.626 4.324 1.626 5.965 0l17.258-17.129a4.174 4.174 0 000-5.921l-9.515-9.444c-1.643-1.628-2.146-4.656-1.121-6.729l2.568-6.174c.758-2.183 3.27-3.97 5.58-3.97h13.487a4.213 4.213 0 004.203-4.201v-24.189a4.216 4.216 0 00-4.203-4.203H494.31c-2.311 0-4.822-1.786-5.58-3.97l-2.568-6.174c-1.024-2.072-.522-5.1 1.121-6.727l9.515-9.444a4.174 4.174 0 000-5.921l-17.258-17.127c-1.641-1.629-4.325-1.629-5.965 0l-9.518 9.443c-1.641 1.627-4.684 2.133-6.762 1.121l-6.263-2.566c-2.188-.748-3.977-3.252-3.977-5.563v-13.319a4.215 4.215 0 00-4.202-4.203h-24.439a4.215 4.215 0 00-4.202 4.203v13.319c0 2.311-1.789 4.814-3.977 5.563l-6.261 2.566c-2.076 1.012-5.121.508-6.762-1.121l-9.517-9.443c-1.642-1.629-4.326-1.629-5.967 0l-17.262 17.127a4.178 4.178 0 000 5.921l9.518 9.444c1.642 1.627 2.145 4.654 1.121 6.727l-2.568 6.174c-.76 2.184-3.27 3.97-5.581 3.97H353.47a4.215 4.215 0 00-4.203 4.203v24.189a4.213 4.213 0 004.203 4.201h13.486c2.312 0 4.821 1.787 5.581 3.97l2.569 6.176c1.024 2.07.522 5.099-1.119 6.727l-9.521 9.444a4.178 4.178 0 000 5.921l17.262 17.129c1.641 1.626 4.325 1.626 5.967-.002l9.515-9.443c1.641-1.629 4.684-2.134 6.762-1.122l6.263 2.567c2.188.748 3.977 3.252 3.977 5.564v13.318z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 418.341c-21.628 0-39.16-17.397-39.16-38.861.001-21.466 17.532-38.862 39.16-38.862s39.16 17.397 39.16 38.86c0 21.465-17.532 38.863-39.16 38.863z"
// 				data-original="#FFAF10"
// 				fill="#ffaf10"
// 			/>
// 			<path
// 				d="M403.388 379.479c0-19.456 14.401-35.569 33.202-38.417a39.763 39.763 0 00-5.956-.445c-21.628 0-39.159 17.397-39.16 38.862 0 21.464 17.532 38.861 39.16 38.861 2.025 0 4.015-.152 5.956-.446-18.801-2.848-33.202-18.961-33.202-38.415z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 424.646c-25.069 0-45.464-20.263-45.464-45.166.001-24.905 20.397-45.167 45.464-45.167 25.069 0 45.465 20.262 45.465 45.165 0 24.905-20.396 45.168-45.465 45.168zm0-77.726c-18.115 0-32.854 14.605-32.855 32.56 0 17.952 14.739 32.56 32.855 32.56 18.117 0 32.855-14.607 32.857-32.562 0-17.953-14.74-32.558-32.857-32.558z"
// 				data-original="#DB722C"
// 				fill="#db722c"
// 			/>
// 			<path
// 				d="M430.634 395.908c-9.143 0-16.554-7.357-16.554-16.429 0-9.076 7.411-16.431 16.554-16.431 9.146 0 16.554 7.354 16.554 16.429 0 9.074-7.409 16.431-16.554 16.431z"
// 				data-original="#FFAF10"
// 				fill="#ffaf10"
// 			/>
// 			<path
// 				d="M425.992 379.479c0-6.987 4.401-12.94 10.598-15.315a16.603 16.603 0 00-5.956-1.115c-9.143 0-16.554 7.354-16.554 16.431 0 9.071 7.411 16.429 16.554 16.429 2.103 0 4.106-.406 5.956-1.115-6.196-2.376-10.598-8.328-10.598-15.315z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 402.211c-12.603 0-22.858-10.197-22.858-22.731 0-12.537 10.255-22.732 22.858-22.732 12.605 0 22.858 10.195 22.858 22.73-.003 12.536-10.255 22.733-22.858 22.733zm0-32.858c-5.652 0-10.249 4.543-10.249 10.126 0 5.58 4.597 10.124 10.249 10.124s10.249-4.544 10.249-10.126c0-5.58-4.597-10.124-10.249-10.124z"
// 				data-original="#DB722C"
// 				fill="#db722c"
// 			/>
// 			<g fill="#445ea0">
// 				<path
// 					d="M140.441 226.608l10.829 10.829a8.939 8.939 0 012.003 3.06l4.692-4.692a9.77 9.77 0 01-3.012-2.051l-10.829-10.828a9.803 9.803 0 01-2.056-3.008l-4.69 4.69a8.93 8.93 0 013.063 2zM252.734 130.761l-5.617-5.617c-.625-.624-1.785-.818-2.578-.432l-12.516 6.108c-.794.387-1.76 1.353-2.146 2.146l-5.565 11.407-62.956 62.956c-2.776-.288-5.633.589-7.779 2.616.719.42 1.396.928 1.997 1.529l10.829 10.828a9.888 9.888 0 011.535 1.992c2.024-2.146 2.899-5 2.612-7.773l62.953-62.953 11.41-5.566c.794-.387 1.76-1.353 2.146-2.146l6.107-12.517c.387-.793.191-1.953-.432-2.578z"
// 					data-original="#445EA0"
// 				/>
// 			</g>
// 			<path
// 				d="M167.749 235.1c-3.538 3.538-9.614 3.251-13.503-.639l-10.829-10.828c-3.889-3.89-4.177-9.966-.639-13.504s9.614-3.251 13.503.639l10.829 10.828c3.889 3.889 4.177 9.965.639 13.504z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M430.432 147.983H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.498 7.498 0 01-7.499 7.5zM430.432 172.471H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.499 7.499 0 01-7.499 7.5zM430.432 196.958H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.498 7.498 0 01-7.499 7.5z"
// 				data-original="#69CDFF"
// 				fill="#69cdff"
// 			/>
// 			<g>
// 				<path
// 					d="M430.432 237.979H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.499 7.5zM430.432 262.466H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.499 7.499 0 01-7.499 7.5zM364.085 286.953H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h65.525c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
// 					data-original="#37C47A"
// 					fill="#37c47a"
// 				/>
// 			</g>
// 			<path
// 				d="M105.584 297.266c-3.889 3.89-10.253 3.89-14.143 0l-10.829-10.828c-3.889-3.89-3.889-10.253 0-14.143l46.394-46.393c3.889-3.89 10.253-3.89 14.142 0l10.829 10.829c3.889 3.889 3.889 10.253 0 14.143l-46.393 46.392z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<g>
// 				<path
// 					d="M97.455 286.438c-3.889-3.89-3.889-10.253 0-14.143l45.043-45.043-1.35-1.351c-3.889-3.89-10.253-3.89-14.142 0l-46.394 46.393c-3.889 3.89-3.889 10.253 0 14.143l10.829 10.828c3.889 3.89 10.253 3.89 14.143 0l1.35-1.35-9.479-9.477zM149.278 216.629c3.538-3.538 9.614-3.251 13.503.639l-6.5-6.5c-3.889-3.89-9.966-4.177-13.503-.639s-3.25 9.614.639 13.504l6.497 6.496c-3.886-3.889-4.172-9.963-.636-13.5z"
// 					data-original="#1A2B63"
// 					fill="#1a2b63"
// 				/>
// 			</g>
// 		</svg>
// 	);
// }

// export default SvgComponent;



// WEBPACK FOOTER //
// ./src/components/Layout/icon.js